import { useEffect, useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'motion/react';
import { fadeMotion } from './motion';
import { CloseIcon } from './icons';
import IconButton from './IconButton';

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
  const reduceMotion = useReducedMotion();
  const motionProps = reduceMotion ? {} : fadeMotion;
  const contentRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      const firstFocusable = contentRef.current.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      firstFocusable?.focus();
    }
  }, [isOpen]);

  const maxWidth = size === 'sm' ? '360px' : size === 'lg' ? '680px' : '520px';

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="aui-modal-backdrop"
          onClick={onClose}
          {...motionProps}
        >
          <motion.div
            ref={contentRef}
            className="aui-modal"
            style={{ maxWidth }}
            onClick={(e) => e.stopPropagation()}
            initial={reduceMotion ? {} : { opacity: 0, scale: 0.96, y: 8 }}
            animate={reduceMotion ? {} : { opacity: 1, scale: 1, y: 0 }}
            exit={reduceMotion ? {} : { opacity: 0, scale: 0.98, y: 4 }}
            transition={{ duration: 0.16, ease: [0.22, 1, 0.36, 1] }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: '0.75rem' }}>
              {title && <h3 style={{ margin: 0 }}>{title}</h3>}
              <IconButton onClick={onClose} title="Cerrar" style={{ marginLeft: 'auto', flexShrink: 0 }}>
                <CloseIcon size={16} />
              </IconButton>
            </div>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
